import { CustomCellEditorProps } from "ag-grid-react";
import { memo } from "react";
import { budgetGridCellSelectClass } from "../BudgetGridCommon";

export default memo(
  (
    params: CustomCellEditorProps & {
      setSubCategoryImportanceScore: (
        budget_sub_category_id: number,
        importanceScore: number
      ) => void;
    }
  ) => {
    const onValueChange = (value: number) => {
      params.data.importance = value;
      params.setSubCategoryImportanceScore(params.data.budget_sub_category_id, value);
      params.stopEditing();
    };

    return (
      <select
        id="importance"
        className={budgetGridCellSelectClass}
        value={params.data.importance ?? ""}
        onChange={(e) => onValueChange(+e.target.value)}
        autoFocus
      >
        <option value="" disabled hidden />
        {Array.from(Array(11).keys()).map((score) => (
          <option key={score} value={score}>
            {score}
          </option>
        ))}
      </select>
    );
  }
);
